import { readableText } from "../lib/colors";

// Derive a compact monogram from the institution's short name.
export function monogram(inst) {
  const caps = (inst.short || "").replace(/[^A-Z0-9]/g, "");
  let m = caps || (inst.short ? inst.short[0].toUpperCase() : "?");
  if (m.length > 4) m = m.slice(0, 4);
  return m;
}

// Circular brand "seal": a real uploaded image when present, else a generated crest.
export function Seal({ inst, size = 48, className = "", testid }) {
  const color = inst.color || "#B8912F";
  const tid = testid || `seal-${inst.rank}`;

  if (inst.seal_image) {
    return (
      <div
        className={`seal seal-photo ${className}`}
        data-testid={tid}
        style={{ width: size, height: size, borderColor: color }}
      >
        <img src={inst.seal_image} alt={`${inst.short} seal`} />
      </div>
    );
  }

  const m = monogram(inst);
  const fs =
    m.length <= 1
      ? size * 0.46
      : m.length === 2
      ? size * 0.36
      : m.length === 3
      ? size * 0.3
      : size * 0.24;
  return (
    <div
      className={`seal ${className}`}
      data-testid={tid}
      style={{
        width: size,
        height: size,
        background: color,
        color: readableText(color),
        fontSize: fs,
      }}
    >
      {m}
    </div>
  );
}
